var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomLeftBoxV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88.359497mm",
    height: "62.742874mm",
    viewBox: "0 0 88.359497 62.742874",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-516.87322,-270.73407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "matrix(1.6975572,0,0,1.6975572,-212.69053,-156.22253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g11-0",
    transform: "translate(110.43793,8.5424298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10-5",
    transform: "translate(-18.704168,0.93433788)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fef1d2",
      fillOpacity: 1,
      strokeWidth: 0.753944,
      paintOrder: "stroke fill markers"
    },
    d: "m 356.06291,242.03558 -17.53883,1.56423 -0.48515,31.13191 14.69341,4.26455 36.94614,-0.88019 0.41142,-35.16228 z",
    id: "path3-3-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fef1d2",
      fillOpacity: 1,
      stroke: "#c78b43",
      strokeWidth: 0.603157,
      strokeDasharray: "1.80947, 1.80947",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "m 355.31206,243.75471 -15.32259,0.89264 -0.24538,28.56882 13.5673,4.42822 35.24138,-0.96304 0.049,-24.63959 0.15798,-7.67326 z",
    id: "path4-4"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeftBoxV2);
export default __webpack_public_path__ + "static/media/BottomLeftBoxV2.f37c34705d70fc23cac254f25e033c9d.svg";
export { ForwardRef as ReactComponent };